(function () {
  Flint.file('views/carouselCards/emrCard.js', function (require) {
    Flint.staticStyles('EmrCard', {
      '$Link': '#_flintapp .ViewEmrCard .ViewLink'
    }, {
      '$Link': {
        alignSelf: 'stretch',
        flexGrow: 1,

        backgroundSize: 'contain',
        backgroundPosition: '50% 50%',
        backgroundRepeat: 'no-repeat'
      }
    });
    Flint.view('EmrCard', function (view, on, $) {
      ;view.render(function () {
        return view.el(['Link', 1], { to: '/enchant-mr-right' });
      });

      '1ee447cb';

      $["Link"] = function (_, _index) {
        return { backgroundImage: 'url(/images/carousel/enchant-mr-right.png)' };
      };
    });
  })
})();
//# sourceMappingURL=emrCard.js.map
